document.addEventListener("latte:init", init);

function init() {

    helper.zipAutoComplete({
        selector: '.input-pcz'
    });

    $('.input-pcz').focus(function(e) {
        //update zipcode from other inputs after page loads
        if (helper.readCookie('userLocation')) {
            $(this).val(helper.readCookie('userLocation'));
        }

        // clear errors
        var thisID = $(this).closest(".zip-entry").attr('id');
        $("#" + thisID + " .required").show();
        $("#" + thisID + " .error-message").hide().removeClass('shake');
    });

    $('.core-feature').click(function(e) {
        if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $('.core-feature-content').slideUp();
            $('.core-feature .fa-angle-up').hide();
            $('.core-feature .fa-angle-down').show();
        } else {
            $('#' + this.id + '-content').slideDown();
            $('#' + this.id + '-up').show();
            $('#' + this.id + '-down').hide();
            $(this).addClass("open");
        }
    });



    $('.search-pcz').click(function(e) {
        var thisID = $(this).attr('name');
        var zip = $('#' + thisID + ' .input-pcz').val();
        if (helper.isValidateZipCode(zip)) {
            helper.createCookie('userLocation', zip, {
                expires: 365
            });
            window.location.href = $(this).attr('data-href'); // get the actual href from the data attribute then redirect it to it.
        } else {
            $('#' + thisID + ' .error-message').removeClass('shake');
            $('#' + thisID + ' .input-pcz').addClass("error");
            $('#' + thisID + ' .label-pcz').addClass("error");
            $('#' + thisID + ' .large-marker').addClass("error");
            $('#' + thisID + ' .mobile-marker').addClass("error");
            $('#' + thisID + ' .required').hide();
            $('#' + thisID + ' .error-message').show();
            $('#' + thisID + ' .error-message').addClass('shake');
        }
    });


    colNum = $('.colgroup').length - 1;

    var totalCols = colNum;

    colNum = 0;

    $('.table-row').each(function() {
        colNum = 0;
        $(this).find('.table-cell').each(function() {
            $(this).addClass('col' + colNum);
            $(this).attr('data-col', colNum);
            colNum++;
            if (colNum > totalCols) {
                colNum = 0;
            }
        });
    });

    $(window).resize(function() {
        var viewportWidth = $(window).width();
        if (viewportWidth < 640) {
            $('.colgroup').mouseover(function() {
                colItems = $(this).attr('data-col');
                $('.table-cell[data-col="' + colItems + '"]').removeClass('hover-class');
            });
            
        } else {
            $('.colgroup').mouseover(function() {
                colItems = $(this).attr('data-col');
                if (colItems > 0) {
                    $('.table-cell[data-col="' + colItems + '"]').addClass('hover-class');
                }
            }).mouseout(function() {
                colItems = $(this).attr('data-col');
                $('.table-cell[data-col="' + colItems + '"]').removeClass('hover-class');
            });
        }
    });  

    //sticks after table compare header reaches view
    var stickyOffset = $('.wider-row').offset() ? $('.wider-row').offset().top : 0;
    $(window).scroll(function(){
      var sticky = $('.wider-row'),
          scroll = $(window).scrollTop();
    if (scroll >= stickyOffset) sticky.addClass('row-stuck');
      else sticky.removeClass('row-stuck');
    });  
}



//////////////////
// WEBPACK FOOTER
// ./public/js/product-compare.js
// module id = 83
// module chunks = 0